import React, { useState } from 'react';
import { 
  Fab, 
  Paper,
  Typography,
  IconButton,
  Popper,
  Fade,
  Box
} from '@mui/material';
import { Message as MessageIcon, Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledFab = styled(Fab)({
  position: 'fixed',
  bottom: 20,
  right: 20,
});

const StyledPaper = styled(Paper)({
  padding: 0,
  maxWidth: 250,
  borderRadius: 10,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
});

const MessageHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '5px 14px',
  borderBottom: '1px solid #eee',
  backgroundColor: '#3B4651',
  borderRadius: '10px 10px 0 0',
  color:'#fff',
  
});

const MessageContent = styled(Box)({
  //textAlign:'justify',
  padding: '16px',
  fontSize: '12px',
  lineHeight: '1.5',
});

const MessageButton = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const currentPath = window.location.pathname;
  if (currentPath.startsWith('/yta')) {
    return null;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledFab 
        sx={{background:"#3B4651","&:hover":{background:"#29323C"}}}
        aria-label="message" 
        onClick={handleClick}
      >
        <MessageIcon sx={{color:"white"}}  />
      </StyledFab>

      <Popper 
        open={open} 
        anchorEl={anchorEl} 
        placement="top-end" 
        transition 
        style={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <StyledPaper sx={{mb:2}}>
              <MessageHeader>
                <Typography variant="subtitle1" style={{ fontWeight: 500, fontSize:'1.1em', textAlign:"justify" }}>
                  Message
                </Typography>
                <IconButton 
                  size="small"
                  onClick={handleClose}
                  style={{ padding: 4 }}
                >
                  <CloseIcon fontSize="medium" sx={{color:'white'}} />
                </IconButton>
              </MessageHeader>
              <MessageContent>
                We are pleased to assist you with your questions and support requests. 
                You can contact our technical team by sending an email to <a href="mailto:info@maytapi.com"><b>info@maytapi.com</b></a>. 
                We will get back to you as soon as possible.
              </MessageContent>
            </StyledPaper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default MessageButton;